"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _cookies = require("@kiwicom/cookies");
var _CookiesCustomize = _interopRequireDefault(require("./components/CookiesCustomize"));
var _CookiesPopup = _interopRequireDefault(require("./components/CookiesPopup"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CookiesPopup = _ref => {
  let {
    disableAnimation = false,
    showRejectAll
  } = _ref;
  const {
    agreed
  } = (0, _cookies.useCookies)();
  const [customize, setCustomize] = React.useState(false);
  const handleOpenCustomize = React.useCallback(() => {
    setCustomize(true);
  }, []);
  const handleCloseCustomize = React.useCallback(() => {
    setCustomize(false);
  }, []);
  if (agreed !== null) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
    id: "cookie_consent" // For ads/i-don't-care-about-cookies blockers
    ,
    "data-test": "CookiesPopup",
    children: [customize && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CookiesCustomize.default, {
      onClose: handleCloseCustomize
    }), !customize && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CookiesPopup.default, {
      onCustomize: handleOpenCustomize,
      disableAnimation: disableAnimation,
      showRejectAll: showRejectAll
    })]
  });
};
var _default = exports.default = CookiesPopup;